export class BookShipmentRequest {
    shipmentInfo: any = {};
    shipmentCostInfo: any = {};
    control: string;
}
